import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch as reduxUseDispatch } from "react-redux";
import { Routes, Route, Navigate } from "react-router-dom";
import { authProtectedRoutes, publicRoutes } from "./routes";
import Authmiddleware from "./routes/route";
import VerticalLayout from "./components/VerticalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";
import NotFound from "./pages/Utility/pages-404"; // Import your 404 component
import MaintenancePage from "./pages/Utility/MaintenancePage"; // Import maintenance page
import "react-toastify/dist/ReactToastify.css"
import { ToastContainer } from "react-toastify"
import "./assets/scss/theme.scss";
// import RequestPermissionComponent from "./RequestPermissionComponent";
import OrderSubscription from "pages/orderManagement/OrderSubscription";
import NotificationSubscription from "./pages/orderManagement/NotificationSubscription";
import { fetchMaintenanceMode } from "./store/maintenance/actions"; // Import maintenance action
import { getCookieValue } from "./helpers/cookieManager"; // Import cookie helper
// import { SpeedInsights } from "@vercel/speed-insights/react"

const getLayout = () => {
  let Layout = VerticalLayout;
  return Layout;
};

const App = () => {
  // Initialize Redux dispatch
  const dispatch = reduxUseDispatch();

  // Get layout type from Redux
  const layoutType = useSelector((state) => {
    return state?.Layout?.layoutType || "vertical";
  });

  // Get maintenance mode from Redux
  const isMaintenanceMode = useSelector((state) => {
    return state?.maintenance?.isMaintenanceMode || false;
  });

  // Get auth state from Redux (this will trigger re-render on login)
  const { userId: reduxUserId, usersessionId: reduxUsersessionId } = useSelector((state) => {
    return {
      userId: state?.Login?.userId,
      usersessionId: state?.Login?.usersessionId,
    };
  });

  const Layout = getLayout(layoutType);

  // Check Redux auth state first, fallback to cookies
  const userId = reduxUserId || getCookieValue("usersessionId");
  const usersessionId = reduxUsersessionId || getCookieValue("usersessionId");

  // Fetch maintenance mode on component mount - only once
  useEffect(() => {
    // Create a flag to track if we've already fetched
    let isMounted = true;

    if (dispatch) {
      dispatch(fetchMaintenanceMode());
    }

    return () => {
      isMounted = false;
    };
  }, []); // Empty dependency array = only runs once on mount

  // Show maintenance page if maintenance mode is ON
  if (isMaintenanceMode) {
    return <MaintenancePage />;
  }

  return (
    <React.Fragment>
        {/* <RequestPermissionComponent /> */}
        {/* <SpeedInsights /> */}
        <NotificationSubscription />
        <OrderSubscription />
         <ToastContainer
        position="top-center"
        autoClose={false}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"

      />

      <Routes>
        {publicRoutes.map((route, idx) => {
          const Component = route.component;
          return (
            <Route
              path={route.path}
              element={<NonAuthLayout>{Component ? <Component /> : null}</NonAuthLayout>}
              key={idx}
              exact={true}
            />
          );
        })}

        {authProtectedRoutes.map((route, idx) => {
          const Component = route.component;
          return (
            <Route
              path={route.path}
              element={
                route.isNavigate ? (
                  <Navigate to={route.navigateTo} />
                ) : userId && usersessionId ? (
                  <Authmiddleware>
                    <Layout>{Component ? <Component /> : null}</Layout>
                  </Authmiddleware>
                ) : (
                  <Navigate to="/login" />
                )
              }
              key={idx}
              exact={true}
            />
          );
        })}

        {/* Add a catch-all route for 404 */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </React.Fragment>
  );
};

App.propTypes = {
  layout: PropTypes.any,
};

export default App;
